import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddEditBooth from "./AddEditBooth";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import * as Yup from "yup";
import classNames from "classnames";
import { Formik, useFormik } from "formik";
import { Dropdown } from "primereact/dropdown";
// ... (existing imports)
// ... (existing imports)

import appUrl from "../../../config/appUrl";

const ManageBooth = () => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const [boothList, setBoothList] = useState([]);
  const [boothId, setBoothId] = useState("");
  const [addEditBooth, setAddEditBooth] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [loading, setLoading] = useState(true); // New state to manage loading
  const [siteValue, setSitevalue] = useState(null);
  const onHide = (name) => {
    setDisplayDialog(false);
  };

  const handleDialog = () => {
    setDisplayDialog(true);
  };

  const editBooth = (rowData) => {
    setDisplayDialog(true);
    setAddEditBooth(true);
    setBoothId(rowData?._id);
  };

  const getBoothList = async () => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}booth/all`
      );
      const data = await response.json();
      setBoothList(data?.data);
      setLoading(false); // Set loading to false after data is fetched
    } catch (error) {
      console.error(error);
    }
  };

  const getSiteList = async () => {
    try {
      const response = await fetch(`${appUrl.BASE_URL}Site/allV2`);
      const data = await response.json();
      setSiteList(data?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getBoothList();
    getSiteList();
  }, []);
  const storedLoginRes = JSON.parse(localStorage.getItem("user"));
  const userTypeIs = storedLoginRes?.role;
  const userSite = storedLoginRes?.site?._id;

  useEffect(() => {
    formik.setFieldValue('site', userSite)
    setSitevalue(userSite)
  }, [userSite])

  useEffect(() => {
    const foundSite = siteList?.find((item) => item?._id === userSite);
    setSitevalue(foundSite)
  }, [userSite, siteList])

  const validationSchema = Yup.object().shape({
    // name: Yup.mixed().required("This field is required."),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    initialValues: {
      site: "",
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };

  const statusTemp = (rowData) => {
    return <>{rowData?.active === true ? "Active" : "InActive"}</>;
  };

  const actionTemp = (rowData) => {
    return (
      <div className="flex">
        <Button
          tooltip="Edit"
          icon="pi pi-user-edit"
          tooltipOptions={{ position: "top" }}
          onClick={() => editBooth(rowData)}
          className="p-button-rounded p-button-text"
        />
        <Button
          tooltip="Delete"
          tooltipOptions={{ position: "top" }}
          onClick={() => confirm(rowData)}
          icon="pi pi-trash"
          className="p-button-rounded p-button-text"
        />
      </div>
    );
  };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-primary",
      rejectClassName: "p-button-danger",
      accept: () => onDeleteConfirmation(rowData),
      reject,
    });
  };

  const onDeleteConfirmation = async (rowData) => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}booth?boothId=${rowData?._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        toast.success("Booth delete");
        await getBoothList();
      } else {
        console.error(data?.msg); // Error message from the API
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reject = () => { };

  // Filter boothList based on the selected site
  const filteredBoothList = formik.values.site
    ? boothList?.filter((booth) => booth.site?._id === formik.values.site)
    : boothList;

  return (
    <>
      <Dialog
        draggable={false}
        visible={displayDialog}
        style={{ width: "55vw" }}
        onHide={() => onHide("displayDialog")}
      >
        <AddEditBooth
          onHide={onHide}
          getBoothList={getBoothList}
          addEditBooth={addEditBooth}
          boothId={boothId}
        />
      </Dialog>

      <div>
        <div className="p-fluid grid align-items-center">
          <div className="col-12 md:col-8">
            <div className="flex align-items-center">
            <h5
                className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                style={{ color: "#17171B" }}
              >
                Booth Management
              </h5>
            </div>
          </div>
          <div className="col-12 md:col-2">
            {/* <label style={{ fontWeight: "bold" }}> Site </label> */}
            <Dropdown
              id="site"
              name="site"
              value={formik.values.site}
              onChange={(e) => {
                formik.setFieldValue('site', e.target.value);
                setSiteId(e.target.value);
              }}
              filter
              filterBy="site"
              filterMatchMode="contains"
              className={classNames(
                { "p-invalid": isFormFieldValid("site") },
                "TextArea__Round border-round-3xl"
              )}
              options={siteList}
              optionLabel="site"
              optionValue="_id"
              placeholder="Select Site"
                  disabled={!!siteValue && siteValue._id === formik.values.site}
                  showClear  
            ></Dropdown>
            {getFormErrorMessage("boothId")}
          </div>

          <div className="col-12 md:col-2 text-right">
            <Button
              label="Add New"
              className="Add__New-Button"
              aria-label="Add Booth"
              onClick={() => {
                handleDialog();
                setAddEditBooth(false);
              }}
              icon="pi pi-plus"
              iconPos="left"
            />
          </div>
        </div>
      </div>

      <div className="card custom_card p-datatable-sm">
        <DataTable
         scrollable
          // scrollHeight="382px"
          responsiveLayout="scroll"
          header=""
          paginator
          rows={10}
          value={loading ? boothList : filteredBoothList}
          emptyMessage="No data found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
          stripedRows
        >
          <Column field="site.site" header="Site"></Column>
          <Column field="name" header="Name"></Column>
          <Column field="direction" header="Direction"></Column>
          <Column field="state" header="State"></Column>
          <Column field="location" header="Location"></Column>
          <Column field="latitude" header="Latitude"></Column>
          <Column field="longitude" header="Longitude"></Column>
          <Column body={statusTemp} header="Status"></Column>
          <Column body={actionTemp} header="Action"></Column>
        </DataTable>
      </div>
    </>
  );
};

export default ManageBooth;
